var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { BaseProvider } from './base';
import { EventName, Events } from '../utils/events';
import { ModalProvider } from './popup/modal';
import { TranslateService } from '@ngx-translate/core';
/**
 * Indicates whether a test set has been created for a dataset
 */
export var TestSetState;
(function (TestSetState) {
    /**
     * No test set has yet been created for the dataset
     */
    TestSetState["None"] = "None";
    /**
     * A test set is in the process of being created for the dataset
     * and test assets are being uploaded
     */
    TestSetState["Uploading"] = "Uploading";
    /**
     * A test set has been created for the dataset
     */
    TestSetState["Created"] = "Created";
    /**
     * A test set is out of sync and we are re-running accuracy on it
     */
    TestSetState["Updating"] = "Updating";
})(TestSetState || (TestSetState = {}));
var TestSetProvider = /** @class */ (function (_super) {
    __extends(TestSetProvider, _super);
    function TestSetProvider(api, events, modalProvider, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.events = events;
        _this.modalProvider = modalProvider;
        _this.translate = translate;
        return _this;
    }
    TestSetProvider.prototype.getRecognitionTestSetResult = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("datasets/" + dataset.id + "/test-set/results")];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (err_1.status == 404) {
                            // No test set has been created
                            return [2 /*return*/, null];
                        }
                        throw err_1;
                    case 3: return [2 /*return*/, response.message];
                }
            });
        });
    };
    TestSetProvider.prototype.getDetectionTestSetResult = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("datasets/" + dataset.id + "/test-set/results")];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _a.sent();
                        if (err_2.status == 404) {
                            // No test set has been created
                            return [2 /*return*/, null];
                        }
                        throw err_2;
                    case 3: return [2 /*return*/, response.message];
                }
            });
        });
    };
    TestSetProvider.prototype.deleteTestSet = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.delete("datasets/" + dataset.id + "/test-set")];
                    case 1:
                        _a.sent();
                        this.events.publish(EventName.TestSetDeleted, dataset.id);
                        return [2 /*return*/];
                }
            });
        });
    };
    TestSetProvider.prototype.rerunAccuracy = function (dataset) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.events.publish(EventName.TestSetUpdating, dataset.id);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.api.post("datasets/" + dataset.id + "/test-set/run")];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        // For now, throw the same event even if an error occurs
                        // to allow subscribers to reset any state
                        this.events.publish(EventName.TestSetUpdated, dataset.id);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TestSetProvider.prototype.confirmDeleteTestSet = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalProvider.presentConfirmationPrompt(this.translate.instant('Delete current test image(s) / results?'), this.translate.instant('Are you sure you would like to delete the current test image(s)?'), this.translate.instant('Delete'))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TestSetProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            Events,
            ModalProvider,
            TranslateService])
    ], TestSetProvider);
    return TestSetProvider;
}(BaseProvider));
export { TestSetProvider };
//# sourceMappingURL=test-set.js.map


// WEBPACK FOOTER //
// ./src/providers/test-set.ts.pre-build-optimizer.js